import { VStack } from "@whoosh/design-system/src/components/primitive";

import {
  RequestTimeSlotRowProps,
  RequestTimeSlotRow,
} from "./RestrictionRequest/RequestTimeSlotRow";
import { TimeSlotRowProps, TimeSlotRow } from "./TimeSlotRow";

type Props = {
  data: (TimeSlotRowProps | RequestTimeSlotRowProps)[];
  id: string;
  clubVisibility?: "PUBLIC" | "PRIVATE" | "SEMI_PRIVATE";
};

const isRequest = (element: any): element is RequestTimeSlotRowProps => {
  return element.hasOwnProperty("restriction");
};

export const CombinedTimeSlotAndRequestRow = ({
  data,
  id,
  clubVisibility,
}: Props) => (
  <VStack>
    {data.map((elm, i) => {
      const position =
        i === 0 ? "first" : i === data.length - 1 ? "last" : "middle";
      return isRequest(elm) ? (
        <RequestTimeSlotRow
          key={`requestSlotRow-${elm.id}-${i}`}
          {...elm}
          position={position}
          clubVisibility={clubVisibility}
        />
      ) : (
        <TimeSlotRow
          key={`timeSlotRow-${id}-${i}`}
          {...elm}
          position={position}
          clubVisibility={clubVisibility}
        />
      );
    })}
  </VStack>
);
